export const SET_DEPOSIT_INVOICES = 'SET_DEPOSIT_INVOICES';
